<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 11 20"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.2665 10.707C9.8615 11.0975 9.2049 11.0975 8.79993 10.707L0.734915 2.92978C0.329938 2.53926 0.329938 1.9061 0.734916 1.51557C1.13989 1.12505 1.79649 1.12505 2.20147 1.51557L10.2665 9.29274C10.6715 9.68327 10.6715 10.3164 10.2665 10.707Z" :fill="fill"/>
    <rect :fill="fill" height="2.03735" rx="1.01867" transform="matrix(0.719836 -0.694145 0.719835 0.694145 0 17.7788)" width="13.2435"/>
  </svg>
</template>

<script>
export default {
  name: 'ChevronRight',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
